// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"449":"10795f","785":"7fb03f","948":"e7b0ae"}[chunkId] + ".js";
};